module.exports = __webpack_public_path__ + "img/delete.94fe9f2b.png";